export default __webpack_public_path__ + "images/9b385067e8bed0779565d21e33b98229.png";